import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/roles/create',
    name: 'roleCreate',
    component: () => import('@/views/restricted/accounts/role/RoleCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_ROLE_CREATE_PERMISSION'],
      menuSelected: 'accounts'
    }
  },
  {
    path: '/roles/:roleId/edit',
    name: 'roleUpdate',
    component: () => import('@/views/restricted/accounts/role/RoleUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_ROLE_UPDATE_PERMISSION'],
      menuSelected: 'accounts'
    }
  }
]
